var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.12482C6 4.73238 8.73237 2 12.1248 2C15.5173 2 18.2496 4.73238 18.2496 8.12482C18.2496 10.6933 16.6001 12.0679 15.2874 12.9647C14.0547 13.8161 13.1775 14.641 13.1775 16.1609V16.8025C13.1775 17.3839 12.7062 17.8552 12.1248 17.8552C11.5435 17.8552 11.0722 17.3839 11.0722 16.8025V16.1609C11.0722 13.5261 12.7606 12.151 14.0934 11.2308L14.0978 11.2277L14.0978 11.2277C15.2903 10.4134 16.1444 9.58815 16.1444 8.12482C16.1444 5.89508 14.3546 4.10526 12.1248 4.10526C9.89508 4.10526 8.10526 5.89508 8.10526 8.12482C8.10526 8.70617 7.63398 9.17745 7.05263 9.17745C6.47128 9.17745 6 8.70617 6 8.12482ZM11.0569 20.9474C11.0569 20.366 11.5282 19.8947 12.1095 19.8947H12.1401C12.7214 19.8947 13.1927 20.366 13.1927 20.9474C13.1927 21.5287 12.7214 22 12.1401 22H12.1095C11.5282 22 11.0569 21.5287 11.0569 20.9474Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHelp);
export default __webpack_public_path__ + "static/media/newHelp.a2d1120a944e263181d801e267296902.svg";
export { ForwardRef as ReactComponent };